import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";
import { touchOnly } from "clutch/src/Style/style.mjs";

import { classNames } from "@/util/class-names.mjs";

const MenuCategoryWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: var(--sp-2);

  min-width: calc(var(--sp-1) * 38);
  width: 100%;
  padding: var(--sp-3) var(--sp-2) var(--sp-1) var(--sp-2);

  &.padding {
    padding-top: var(--sp-5);
  }

  > span {
    flex: 1;
    color: var(--shade0);
  }

  ${touchOnly} {
    padding: unset;

    span {
      color: var(--shade2);
    }
  }
`;

const MenuCategory = ({
  text,
  hasPadding,
}: {
  text: Translation;
  hasPadding?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <MenuCategoryWrapper {...classNames("category", hasPadding && "padding")}>
      <span className="type-overline">{t(...text)}</span>
    </MenuCategoryWrapper>
  );
};

export default MenuCategory;
